export const customFieldsCopy = {
  pageTitle: "Custom Fields",
  pageSubtitle: "Reusable fields used to describe products and production processes.",
  addField: "+ Add Field",
  addFieldShort: "Add Field",
  myFields: "My Fields",
  browseFields: "Browse Fields",
  searchFields: "Search fields",
  field: "Field",
  type: "Type",
  usedIn: "Used in",
  source: "Source",
  requiredOnPublish: "Required on publish",
  visibility: "Visibility",
  visibilityPublic: "Public",
  visibilityInternal: "Internal",
  status: "Status",
  actions: "Actions",
  enabled: "Enabled",
  disabled: "Disabled",
  edit: "Edit",
  removeFromFutureUse: "Remove from future use",
  reEnable: "Re-enable",
  addToStudio: "Add to Studio",
  added: "Added",
  createNewField: "+ Create New Field",
  cancel: "Cancel",
  saveField: "Save Field",
  addFieldTitle: "Add Field",
  editFieldTitle: "Edit Field",
  fieldName: "Field Name",
  description: "Description",
  fieldType: "Field Type",
  options: "Options",
  addOption: "+ Add option",
  unit: "Unit",
  tags: "Tags",
  advanced: "Advanced",
  sourceGlobal: "Global",
  sourceStudio: "Your Studio",
  usedInProduct: "Product",
  usedInProcess: "Process",
  usedInBoth: "Product + Process",
  usedInProductHelp: "Record once against the finished product.",
  usedInProcessHelp: "Record while documenting a production process.",
  usedInBothHelp: "Can be recorded in both places.",
  emptyMyFields: "No custom fields are enabled for this studio yet.",
  browseFieldsCta: "Browse fields",
  noSearchResults: "No matching fields found.",
  alreadyExists: "already exists",
  useExisting: "Use existing field",
  productAttributes: "Product Attributes",
  productAttributesHelp:
    "To save a draft, add a product name and colour. Artform, type, category, sub-category, weave type and fields marked * here are needed to publish.",
  historicalTitle: "Historical / Archived Attributes",
  processFieldsTitle: "Fields used in this process",
  unableToPublish: "Unable to publish",
  completeRequired: "Complete required fields",
  configLoadWarning: "Custom fields could not be loaded. You can still save the rest of this product.",
  removeUnusedConfirm: "Remove this field from future use?",
  removeUsedWarning:
    "This field is already used in existing products/processes. Removing it will stop it from appearing in future forms. Historical values will be preserved.",
  optionUsedHint: "Deactivate saved options to hide them from future selection. Historical values remain.",
  filterAll: "All",
  filterProduct: "Product",
  filterProcess: "Process",
  filterBoth: "Product + Process",
  filterSourceAll: "All",
  filterSourceGlobal: "Global",
  filterSourceStudio: "Studio",
};

export const fieldTypeLabels: Record<string, string> = {
  TEXT: "Text",
  NUMBER: "Number",
  SINGLE_SELECT: "Single Select",
  MULTI_SELECT: "Multi Select",
  BOOLEAN: "Yes / No",
  DATE: "Date",
  RICH_CONTENT: "Text & Media",
};

export const usedInLabels: Record<string, string> = {
  PRODUCT: "Product",
  PROCESS: "Process",
  BOTH: "Product + Process",
};

export const unitSuggestions = [
  "grams",
  "kg",
  "cm",
  "metres",
  "hours",
  "°C",
  "pH",
  "knots",
  "count",
  "%",
];
